/* global geolocator */

import _ from 'lodash';

export default class GeolocUtils {

  static PARIS_LOCATION = {
    latitude: 48.864716,
    longitude: 2.349014,
  };


  static NULL_VALUE = -1;

  /**
   *
   * Returns the distance between the two given `GeoPt` as kilometers
   */
  static getDistanceBetweenPoints(from: GeoPt, to: GeoPt): Kilometers {

    if (_.isNil(from) || _.isNil(to)) {
      return GeolocUtils.NULL_VALUE;
    }

    /**
     * http://onury.github.io/geolocator/
     */
    if (!_.isNil(geolocator)) {
      return geolocator.calcDistance({
          from,
          to,
          formula: geolocator.DistanceFormula.HAVERSINE,
          unitSystem: geolocator.UnitSystem.METRIC
      });
    }

    console.warn('GeolocUtils:getDistanceBetweenPoints without global geolocator is not implemented. see http://onury.github.io/geolocator/');

    return -1;
  }

  static shortGeoPtToGeoPt(shortGeoPt: ShortGeoPt): GeoPt {
    if (_.isNil(shortGeoPt)) {
      return {
        latitude: 0,
        longitude: 0
      };
    }
    return {
      latitude: shortGeoPt.lat,
      longitude: shortGeoPt.lng
    };
  }

  static geoPtToShortGeoPt(geoPt: GeoPt): ShortGeoPt {
    if (_.isNil(geoPt)) {
      return {
        latitude: 0,
        longitude: 0
      };
    }
    return {
      lat: geoPt.latitude,
      lng: geoPt.longitude
    };
  }

  static getLabelForDistanceInKm(distance: Kilometers): string {
    if (_.isNaN(distance)) {
      return ('');
    }
    if (distance > 1) { // more than 1 km
      return `${distance.toFixed(1)} km`;
    }

    // meters
    return `${Math.floor((distance * 1000))} m`;
  }

  static kmToMeters(distanceInKm: Kilometers): Meters {
    return distanceInKm / 1000;
  }
}
